module.exports = __webpack_public_path__ + "static/media/tojo.3eb7eb7e.png";